<!-- <mat-icon *ngIf="editable" (click)="clickBtn()" svgIcon="icon-address-location" matTooltip="Edit geometry"></mat-icon> -->
<!-- <div class="icon-general map-icon">
    <i *ngIf="editable" (click)="clickBtn()" class="glyphicons glyphicons-pencil"></i>
</div> -->
<mat-icon class="icon-general" (click)="clickBtn()" svgIcon="icon-address-association" matTooltip="Open Address Association Wizard"></mat-icon>
